// extracted by mini-css-extract-plugin
export var sidebar = "sidebar-module--sidebar--8EHVK";
export var link = "sidebar-module--link--iib0d";
export var about = "sidebar-module--about--rAvD3";
export var cover_author_image = "sidebar-module--cover_author_image--tRB0D";
export var author_name = "sidebar-module--author_name--Kt9AQ";
export var contact = "sidebar-module--contact--ODE0k";
export var contact_title = "sidebar-module--contact_title--Lbo+P";
export var copyright = "sidebar-module--copyright--IW3PU";
export var link_wrapper = "sidebar-module--link_wrapper--dmjfB";